/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_DescriptionInputs */

const es_prompt_tips_description = /** @type {(inputs: Prompt_Tips_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguí estos consejos para obtener respuestas más precisas y útiles del agente.`)
};

const en_prompt_tips_description = /** @type {(inputs: Prompt_Tips_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow these tips to get more accurate and useful answers from the agent.`)
};

/**
* | output |
* | --- |
* | "Follow these tips to get more accurate and useful answers from the agent." |
*
* @param {Prompt_Tips_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_description = /** @type {((inputs?: Prompt_Tips_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_description(inputs)
	return en_prompt_tips_description(inputs)
});
export { prompt_tips_description as "prompt_tips.description" }